import { render, staticRenderFns } from "./PicturesAnswers.vue?vue&type=template&id=78555d44&scoped=true"
import script from "./PicturesAnswers.vue?vue&type=script&lang=js"
export * from "./PicturesAnswers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78555d44",
  null
  
)

export default component.exports